import { Group } from "three";
import { config } from "./config";
import MilestoneTitle from "./MilestoneTitle.js";
import MilestoneEvent from "./MilestoneEvent.js";

class MilestoneManager {
    constructor() {
        this.group = new Group();
        this.lastAddedPosition = 0;

        this.titleObjects = [];
        this.eventObjects = [];
    }

    init(milestonesData) {
        if (!milestonesData || !milestonesData.title) return this.group;
        this.milestonesData = milestonesData;

        // Add title
        this.addMilestoneTitle(milestonesData.title, 0);

        // Add milestone data
        if (milestonesData.data && milestonesData.data.length > 0) {
            milestonesData.data.forEach((milestone, index) => {
                // Add milestone title
                this.addMilestoneTitle(
                    [milestone.name, milestone.title],
                    index + 1,
                );
                // Add milestone events
                if (milestone.events) {
                    milestone.events.forEach((event, idx) => {
                        this.addMilestoneEvent(event, index + 1, idx);
                    });
                }
            });
        }

        this.adjustMilestonePositions();

        return this.group;
    }

    addMilestoneTitle(title, index) {
        const milestoneTitle = new MilestoneTitle(title, index);

        const gap = 100;
        //  initial position logic: position relative to the previous milestone
        if (this.lastAddedPosition === 0) {
            milestoneTitle.position.z = milestoneTitle.eleW / 2;
        } else {
            milestoneTitle.position.z =
                this.lastAddedPosition + milestoneTitle.eleW / 2 + gap;
        }

        this.group.add(milestoneTitle);
        this.titleObjects.push(milestoneTitle);

        this.lastAddedPosition = milestoneTitle.position.z;
        // Add width as reference for next milestone
        this.lastAddedPosition += milestoneTitle.eleW / 2;
        return milestoneTitle;
    }

    addMilestoneEvent(event, milestoneIndex, eventIndex) {
        const milestoneEvent = new MilestoneEvent(
            event,
            milestoneIndex,
            eventIndex,
        );
        const gap1 = 100;
        const gap2 = 300;

        // Position logic could be added here
        if (eventIndex === 0) {
            milestoneEvent.position.z = this.lastAddedPosition + gap1;
        } else {
            milestoneEvent.position.z = this.lastAddedPosition + gap2;
        }

        this.group.add(milestoneEvent);

        this.lastAddedPosition = milestoneEvent.position.z;
        return milestoneEvent;
    }

    adjustMilestonePositions() {
        if (this.group.children.length === 0) return;

        // Calculate once outside the loop
        const baseOffset =
            this.lastAddedPosition +
            config.timeline.charging +
            config.timeline.boosting;

        // Apply in batch to minimize calculations
        this.group.children.forEach((child) => {
            child.position.z = baseOffset - child.position.z;
        });

        // set starting time through milestone length
        config.timeline.starting =
            this.lastAddedPosition + config.enteringOffset;
    }

    updateLayout(windowWidth) {
        this.titleObjects.forEach((child) => {
            if (child instanceof MilestoneTitle && child.updateLayout) {
                child.updateLayout(windowWidth);
            }
        });
    }

    destroy() {
        this.group.children.forEach((child) => {
            if (child instanceof MilestoneTitle) {
                child.destroy();
            }
            if (child instanceof MilestoneEvent) {
                child.destroy();
            }
        });
    }
}

export default MilestoneManager;
